interface ErrorBannerProps {
  message: string
  errorId?: string | null
  onDismiss: () => void
}

function ErrorBanner({ message, errorId, onDismiss }: ErrorBannerProps) {
  return (
    <div className="flex items-center justify-between rounded-md border border-red-300 bg-red-50 px-4 py-3">
      <div className="text-sm text-red-700">
        <p>{message}</p>
        {errorId ? (
          <p className="mt-1 font-mono text-xs text-red-600">
            Reference ID: <span data-testid="error-id">{errorId}</span>
          </p>
        ) : null}
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="text-red-700 hover:text-red-900"
        aria-label="Dismiss error"
      >
        &times;
      </button>
    </div>
  )
}

export default ErrorBanner
